export enum RegionRouteName {
    Index = 'system.regions.index',
    Create = 'system.regions.create',
    Edit = 'system.regions.edit',
}

export default {
    path: 'regions',
    name: RegionRouteName.Index,
    component: () => import('@/views/system/region/Index.vue'),
    meta: {
        auth: true,
        label: 'Regions',
        icon: 'fal fa-registered fa-fw',
        group: 'main',
        location: 'sidebar',
        permission: 'manage-regions',
    },
    children: [
        {
            path: 'create',
            name: RegionRouteName.Create,
            component: () => import('@/views/system/region/Index.vue'),
            meta: {
                auth: true,
                label: 'Create Region',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-regions',
            },
        },
        {
            path: ':regionId/edit',
            name: RegionRouteName.Edit,
            component: () => import('@/views/system/region/Index.vue'),
            meta: {
                auth: true,
                label: 'Edit Region',
                group: 'main',
                location: 'sidebar',
                permission: 'manage-regions',
            },
        },
    ],
}
